import { Pipe, PipeTransform } from '@angular/core';
import { Engagement, OldPortfolio } from '@ddt-web/domain';

import { JsonToPortfolioPipe } from './json-to-portfolio.pipe';

@Pipe({
	name: 'jsonToEngagement'
})
export class JsonToEngagmentPipe implements PipeTransform {
	private jsonToPortfolioPipe: JsonToPortfolioPipe = new JsonToPortfolioPipe();

	public transform(portfolioData: any): Engagement {
		const engagement: Engagement = new Engagement();
		const portArray: Array<OldPortfolio> = [];

		if (portfolioData?.advisorName) {
			engagement.advisorName = portfolioData.advisorName;
		}
		if (portfolioData?.asOfDate) {
			engagement.asOfDate = portfolioData.asOfDate;
		}
		if (portfolioData?.dateLastShared) {
			engagement.dateLastShared = portfolioData.dateLastShared;
		}
		if (portfolioData?.dateLastModified) {
			engagement.lastModifiedDate = portfolioData.dateLastModified;
		}
		if (portfolioData?.children) {
			for (const portfolioJsonObject of portfolioData.children) {
				const port: OldPortfolio = this.jsonToPortfolioPipe.transform(portfolioJsonObject);
				portArray.push(port);
			}
			engagement.portfolios = portArray;
		}
		if (portfolioData?.emailAddress) {
			engagement.emailAddress = portfolioData.emailAddress;
		}
		if (portfolioData?.firmName) {
			engagement.firmName = portfolioData.firmName;
		}
		if (portfolioData?.portfolioStrategist) {
			engagement.portfolioStrategist = portfolioData.portfolioStrategist;
		}
		if (portfolioData?.sharedAdvisorEmailList) {
			engagement.sharedAdvisorEmailList = portfolioData.sharedAdvisorEmailList;
		}
		if (portfolioData?.title) {
			engagement.title = portfolioData.title;
		}
		if (portfolioData?.userEmail) {
			engagement.userEmail = portfolioData.userEmail;
		}
		if (portfolioData?.uniqueId) {
			engagement.uniqueId = portfolioData.uniqueId;
		}
		if (portfolioData?.type) {
			engagement.type = portfolioData.type;
		}
		if (portfolioData?.finalFlag) {
			engagement.finalFlag = portfolioData.finalFlag;
		}
		if (portfolioData?.pdfDataPortfolioDate) {
			engagement.pdfDataPortfolioDate = portfolioData.pdfDataPortfolioDate;
		}
		if (portfolioData?.pdfDataAsOfDate) {
			engagement.pdfDataAsOfDate = portfolioData.pdfDataAsOfDate;
		}
		if (portfolioData?.pdfDateCreated) {
			engagement.pdfDateCreated = portfolioData.pdfDateCreated;
		}
		if (portfolioData?.displayName) {
			engagement.displayName = portfolioData.displayName;
		}

		return engagement;
	}
}
